/** @jsxImportSource @emotion/react */

import { SocialBox } from "components/desktop/SocialBox";
import { Footer } from "components/desktop/ui/Footer";
import { HeaderWebsite } from "components/desktop/ui/Header";
import Menu from "components/desktop/ui/Menu";
import ModalGroup from "components/desktop/ui/ModalGroup";
import { Outlet, useOutletContext } from "react-router-dom";
import { outletContextType } from "types";

import { DefaultLayoutStyle } from "./index.style";

export const DefaultLayout = () => {
  const { openNotification } = useOutletContext<outletContextType>();

  return (
    <div css={DefaultLayoutStyle.index}>
      <HeaderWebsite />
      <Menu />
      <main css={DefaultLayoutStyle.main}>
        <Outlet context={{ openNotification } as outletContextType} />
      </main>
      <Footer />
      <SocialBox />
      <ModalGroup />
    </div>
  );
};

export default DefaultLayout;
